import { useState } from 'react'

export const useDialog = () => {
  const [open, setOpen] = useState(false)
  const toggle = () => setOpen(!open)
  const close = () => setOpen(false)

  return { open, setOpen, toggle, close }
}
